import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/AuthSlice';
import themeConfigReducer from './slices/ThemeConfigSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';


const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'] // only auth reducer will be persisted
};

const rootReducer = combineReducers({
    auth: authReducer,
    themeConfig: themeConfigReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);


export const store = configureStore({
    reducer: {
        store: persistedReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        })
});

export const persistor = persistStore(store);

export default store;